import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getCampusSUAIO() {
    const response = await axios.get("/api/suaio/campus/referent");
    return response.data;
  },

  async getListeCampus() {
    const response = await axios.get("/api/admin/campus");
    return response.data;
  },
  async getCampus(id) {
    const response = await axios.get("/api/admin/campus/" + id);
    return response.data;
  },
  async deleteCampus(id) {
    const response = await axios.delete("/api/admin/campus/" + id);
    return response.data;
  },
  async addCampus(campus) {
    const response = await axios.post("/api/admin/campus", campus);
    return response.data;
  },
  async updateCampus(id, campus) {
    const response = await axios.put("/api/admin/campus/" + id, campus);
    return response.data;
  },
  async getCampusLst() {
    const response = await axios.get("/api/campus");
    return response.data;
  },
};
